import usePrivateAxios from '@/common/api/usePrivateAxios'
import { RoleData, RoleResponse } from '@/common/types/roles'
import { useQuery } from '@tanstack/react-query'

interface UseClientRoleProps {
  id: string
}

export const useClientRole = ({ id }: UseClientRoleProps) => {
  const privateAxios = usePrivateAxios()

  return useQuery<RoleResponse, unknown, RoleData>({
    queryKey: ['clientRole', id],
    queryFn: () => {
      return privateAxios.get(`/client/roles/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}
